<script setup>
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
import {reactive} from "vue";

import {Bar} from "vue-chartjs";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const chartData = reactive({
  labels: ['January', 'February', 'March'],
  datasets: [{data: [40, 20, 12]}]
})

const chartOptions = reactive({
  responsive: true,
  indexAxis: 'y'
})

</script>
<template>
  <Bar
    id="randomID"
    :options="chartOptions"
    :data="chartData"
  >

  </Bar>
</template>


<!--<script>-->
<!--import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js';-->
<!--import {reactive} from 'vue';-->
<!--import {Bar} from 'vue-chartjs';-->

<!--ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);-->

<!--export default {-->
<!--  components: {-->
<!--    Bar-->
<!--  },-->
<!--  setup() {-->
<!--    // Define reactive chart data-->
<!--    const chartData = reactive({-->
<!--      labels: ['January', 'February', 'March'],-->
<!--      datasets: [{ data: [40, 20, 12] }]-->
<!--    });-->

<!--    // Define reactive chart options-->
<!--    const chartOptions = reactive({-->
<!--      responsive: true-->
<!--    });-->

<!--    // Return data and options so that the render function can access them-->
<!--    return {-->
<!--      chartData,-->
<!--      chartOptions-->
<!--    };-->
<!--  }-->
<!--};-->
<!--</script>-->

<!--<template>-->
<!--  <Bar-->
<!--    id="randomID"-->
<!--    :options="chartOptions"-->
<!--    :data="chartData"-->
<!--  />-->
<!--</template>-->
